<template>
	<div class="LoginWarp">
		<div class="Loginbox typeArae">
			<div class="leftwarp">
				<div class="imgbox">
					<img src="@/assets/imgs/login/logo1.png" />
				</div>
				<div class="toptitleBox">
					<!-- <div class="returnhome" @click="gohome">
						<i class='el-icon-caret-left' /> 返回首页</div> -->
					<div class="handleBox">
						<div class="loginbtn">登录</div>
						<div class="registbtn" @click="goregist">注册</div>

					</div>
				</div>
				<div class="formbox">
					<div class="btnbox">
						<div v-for="(item,index) in btntype" :key="index" :class="activebtnname==item.name?'activename':'name'" @click="changeloginFn(item)">{{item.name}}</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="formwarp" label-position='top'>
						<!-- <el-form-item label="手机号" prop="phoneNumber" v-if="activebtnname=='验证码登录'">
						<el-input placeholder="请输入手机号" v-model="ruleForm.phoneNumber" class="input-with-select">
							<el-select v-model="areacode" slot="append" placeholder="请选择" style="width:80px">
								<el-option label="+86" value="1"></el-option>
							</el-select>
						</el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="identfyCode" v-if="activebtnname=='验证码登录'">
						<el-row :gutter="20">
							<el-col :span="18">
								<el-input v-model="ruleForm.identfyCode"></el-input>
							</el-col>
							<el-col :span="6" style="padding:0px">
								<div class="getcodebtn" @click="getcodeFn">
									<el-button :disabled='disable'>{{showtimeContent}}</el-button>
								</div>
							</el-col>
						</el-row>
					</el-form-item> -->
						<!-- 用户名密码 -->
						<el-form-item label="用户名" v-if="activebtnname=='密码登录'" prop="userName">
							<el-input v-model="ruleForm.userName" @keyup.enter.native="login"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="password" v-if="activebtnname=='密码登录'">
							<!-- prefix-icon="el-icon-key" -->
							<el-input v-model="ruleForm.password" type="password" placeholder="请输入密码" @keyup.enter.native="login" show-password>
								<!-- <i slot="suffix" class="el-icon-view" @click="showPwd"></i> -->
							</el-input>
						</el-form-item>

						<!-- 微信登录 -->
						<div class="wechartpwd">
							<div class="wechartBtnbox">
								<div class="returnhome" @click="gohome">
									<i class='el-icon-caret-left' /> 返回首页</div>
								<!-- <img src='@/assets/imgs/login/wechart.png' />
							<span>微信登录</span> -->
								<!-- <div id="wxcode">
								</div> -->
							</div>
							<div class="forgetpwd" @click="gofindpwd">
								忘记密码?
							</div>
						</div>
						<el-form-item>
							<el-button type="primary" class="savebtnbox" @click="submitForm('ruleForm')" style="width:100%">登录</el-button>
						</el-form-item>
						<div class="wechartBox">
							<div class="line"></div>
							<div class="chartImg" @click="wechartLogin">
								<img src='@/assets/imgs/login/wechart.png' class="img" />
								<span class="waytext">其他登录方式</span>
							</div>
							<div class="line"></div>
						</div>
					</el-form>
				</div>
				<div class="tiptext">
					如果您有任何疑问或在登录过程中遇到任何困难，您都可以通过以下方式与我们联系电话：17200303981
				</div>
			</div>
			<div class="rightwarp">
				<img src="@/assets/imgs/login/logo2.png" />
				<div class="textBox">
					<div>欢迎登录</div>
					<div>中国人才交流协会</div>
				</div>
			</div>
		</div>
		<el-dialog title="" :visible.sync="codeVisible" width="480px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
		    :close="offloginVisible">
			<div class="codeBox">
				<div id="wxcode">
				</div>
			</div>
		</el-dialog>
		<!-- <div class="codeBox">
				<div id="wxcode">
				</div>
			</div> -->

	</div>
</template>
<script>
import { httpService } from "@/service/httpService";

export default {
	data() {
		return {
			showtime: '',
			showtimeContent: '发送验证码',
			disable: true,
			btntype: [
				// { name: '验证码登录' },
				{ name: '密码登录' },
			],
			activebtnname: '密码登录',
			// 区号
			areacode: '1',
			ruleForm: {
				userName: '',
				password: '',
				// identfyCode: '',
				// phoneNumber: '',
			},
			rules: {
				userName: [
					{ required: true, message: '请输入用户名,用户名建议以"拼音+数字"组合', trigger: 'blur' },
					// {
					// 	required: true, message: '用户名不能输入中文', pattern: /^[a-zA-Z0-9_]{0,}$/, trigger: 'blur'
					// }
				],
				phoneNumber: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
					}
				],
				identfyCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
			},
			codeVisible: false,
		}
	},
	mounted() {
		this.createWxQrcode()
	},
	methods: {
		goregist() {
			this.$router.push('/regist');
		},
		gohome() {
			this.$router.push('/');
			sessionStorage.setItem('clickMenu', '首页')
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					httpService.loginFn(this.ruleForm).then(res => {
						if (res.code == 200) {
							let data = res.result
							sessionStorage.setItem('clickMenu', '首页')
							sessionStorage.setItem('token', data.token)
							sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
							this.$router.push('/');
						} else {
							this.$message.error(res.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		login() {
			this.submitForm('ruleForm')
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		changeloginFn(item) {
			this.activebtnname = item.name
		},
		async getcodeFn() {
			let data = await httpService.loginCodeFn(this.ruleForm.phoneNumber);
			if (data.code == 200) {
				this.showtime = 120,
					this.showtimeContent = '已发送'
				this.disable = true
				// this.newsData = data.result.list
				let timeChange;
				//关键在于用ti取代time进行计算和判断，因为time在render里不断刷新，但在方法中不会进行刷新
				const clock = () => {
					let ti = this.showtime;
					if (ti > 1) {
						//当ti>0时执行更新方法
						ti = ti - 1;
						this.showtime = ti,
							this.showtimeContent = '已发送' + ti + 's'
					} else {
						//当ti=0时执行终止循环方法
						clearInterval(timeChange);
						this.showtime = '',
							this.showtimeContent = '发送验证码',
							this.disable = false
					}
				};
				// 弹框
				if (this.disable) {
					//每隔一秒执行一次clock方法
					timeChange = setInterval(clock, 1000);
				} else {
					clearInterval(timeChange);
				}
			}
		},
		gofindpwd() {
			this.$router.push({
				path: '/retrieve-password',
				query: {
					name: '找回密码'
				}
			})
		},
		createWxQrcode() {
			// 生成微信登录二维码
			var obj = new WxLogin({
				// self_redirect: false,
				id: "wxcode", // 页面显示二维码的容器id
				appid: "wx0ca107b920ae43d4", // 微信官方提供的测试id
				scope: "snsapi_login",
				redirect_uri: encodeURI("http://www.zgrcjlxh.com"), // 微信官方中的测试地址
				// state: "bind",
				style: "black",
				href: "",
			});
		},
		wechartLogin() {
			this.$message('功能开发中，敬请期待！')
			// this.codeVisible = true
			// this.$nextTick(function () {
			// 	// let qrBox = document.getElementById('qrcode')    // 获取到div元素
			// 	this.createWxQrcode()
			// })
		},
		offloginVisible() {
			this.codeVisible = false
		},
	}
}
</script>
<style lang="less" scoped>
.LoginWarp {
	width: 100%;
	height: 100%;
	background: url(../assets/imgs/login/img1.png) #fff no-repeat;
	background-size: 100% 100%;
	// overflow: hidden;
	box-sizing: border-box;
	margin: auto;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	.Loginbox {
		width: 1200px;
		padding: 60px 0 0px 0px;
		box-sizing: border-box;
		box-sizing: border-box;
		min-height: 937px;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		margin: 0 auto;
		.leftwarp {
			display: flex;
			flex-direction: column;
			width: 588px;
			align-items: center;
			.imgbox {
				width: 98px;
				height: 98px;
				background: #fff;
				box-shadow: 0px 15px 16px rgba(0, 0, 0, 0.07);
				border-radius: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 36px;
				img {
					width: 65px;
					height: 60px;
					margin: auto 0;
				}
			}
			.toptitleBox {
				width: 100%;
				display: flex;
				flex-direction: row;
				align-items: center;
				margin-bottom: 33px;
				font-size: 22px;
				.returnhome {
					width: 130px;
					// font-size: 24px;
					color: #0083ff;
					cursor: pointer;
				}
			}
			.handleBox {
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				// padding: 0 123px 0 3px;
				box-sizing: border-box;
				font-size: 24px;
				.loginbtn {
					// font-size: 24px;
					color: #0083ff;
				}
				.registbtn {
					// font-size: 24px;
					color: #333333;
					cursor: pointer;
				}
			}
			.formbox {
				width: 588px;
				height: 502px;
				box-shadow: 0px 3px 10px rgba(232, 232, 232, 0.52);
				background: #fff;
				.btnbox {
					display: flex;
					flex-direction: row;
					justify-content: center;
					font-size: 20px;
					line-height: 24px;
					margin: 27px 0 30px 0;
					.activename {
						color: #0083ff;
						cursor: pointer;
						position: relative;
						margin: 0 50px;
						&::before {
							content: '';
							position: absolute;
							width: 20px;
							height: 0px;
							border: 2px solid #448df7;
							opacity: 1;
							background: #448df7;
							left: 50%;
							transform: translateX(-50%);
							top: 30px;
						}
					}
					.name {
						cursor: pointer;
						color: #43424b;
						margin: 0 50px;
					}
				}
				.formwarp {
					padding: 0 73px;
					.getcodebtn {
						/deep/.el-button {
							border: none;
							width: 104px;
							height: 45px;
							background: rgba(0, 131, 255, 0.1);
							color: #0083ff;
							font-size: 16px;
							text-align: center;
							padding: 0;
						}
					}
					/deep/.el-input__inner {
						height: 45px;
						line-height: 45px;
					}
					.wechartpwd {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						font-size: 16px;
						margin: 32px 0;
					}
					.wechartBox {
						display: flex;
						flex-direction: row;
						justify-content: center;
						align-items: center;
						.line {
							width: 40px;
							height: 1px;
							background: #e5e5e5;
						}
						.chartImg {
							display: flex;
							flex-direction: column;
							align-content: center;
							justify-content: center;
							align-items: center;
							cursor: pointer;
							margin: 0 10px;
							.img {
								width: 28px;
								height: 23px;
							}
							.waytext {
								font-size: 14px;
								color: #666;
							}
						}
					}
					.wechartBtnbox {
						display: flex;
						flex-direction: row;
						align-items: center;
						cursor: pointer;
						img {
							width: 23px;
							height: 18.7px;
						}
						span {
							margin-left: 8px;
							color: #333333;
						}
						.returnhome {
							width: 130px;
							// font-size: 24px;
							color: #0083ff;
							cursor: pointer;
						}
					}
					.forgetpwd {
						color: #6788ff;
						cursor: pointer;
					}
					.savebtnbox {
						height: 50px;
						background: #0083ff;
						font-size: 16px;
						box-shadow: 0px 7px 22px rgba(103, 154, 255, 0.44);
					}
				}
			}
			.tiptext {
				width: 560px;
				font-size: 16px;
				line-height: 24px;
				color: #a6a9b7;
				margin: 21px 0;
			}
		}
		.rightwarp {
			margin: 200px 0 0 120px;
			.textBox {
				font-size: 60px;
				font-weight: bold;
				line-height: 88px;
				color: #ffffff;
				margin-top: 22px;
			}
		}
	}
}
.dialogWarp {
	/deep/.codeBox {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
}
</style>


